import { Controller } from "@hotwired/stimulus"

// Uogólniony kontroler do opcji masowych
// aby działał poprawnie wystarczy do checkboxów które mają być użyte w opcjach masowych dodać nazwę "ids[]"
// opcjonalne targety:
// counter - wyświetlamy informację o ilości obecnie zaznaczonych elementów (musi być postaci typu <div target="counter"> <div> ILOŚĆ </div> </div>)
// list - ograniczamy się do checkboxów będącymi podelementami listy
// select - używane do zaznaczania wszystkich checkboxów na raz

// Connects to data-controller="bulk-options-advanced"
export default class extends Controller {
  static targets = ["counter", "list", "select", "optionsDiv", "thead", "form", "hiddenField", "breadcrumbsArea"]
  static values = { loaded: Boolean }
  lastElement = null
  inputs = []

  connect() {
    this.inputs = this.list().querySelectorAll("input[name=\"ids[]\"]")
    console.log("connect1 bulk options advanced")

    this.setInputs()
    this.updateCounter()

    this.loadedValue = true

    this.handleStreamRender = this.handleStreamRender.bind(this)
    window.addEventListener("turbo:before-stream-render", this.handleStreamRender)
  }

  disconnect() {
    // Clean up event listener when the controller disconnects
    window.removeEventListener("turbo:before-stream-render", this.handleStreamRender)
  }

  handleStreamRender(event) {
    // Check if the event is targeting our details frame
    const targetFrameId = event.target.getAttribute("target")

    if (targetFrameId === "index_email") {
      setTimeout(() => {
        // reset listy inputów, żeby działało zaznaczanie z shiftem
        console.log("bulk reload checkboxes")
        this.inputs = this.list().querySelectorAll("input[name=\"ids[]\"]")
      }, 1000)
    }

    if (this.hasSelectTarget) {
      this.selectTarget.checked = false
      document.getElementById("bulk-advanced-unchecked-all")?.classList?.add("hidden")
      document.getElementById("bulk-advanced-checked-all")?.classList?.add("hidden")
    }
  }

  // ustawienie początkowe checkboxów, w tym dodanie akcji po kliknięciu
  setInputs() {
    // ustawiamy data-action dla inputów o odpowienich id
    if (this.inputs) {
      this.inputs.forEach(element => {
        element.setAttribute("data-action", "click->bulk-options-advanced#checkOption")
      })
    }

    if (this.hasSelectTarget) {
      this.selectTarget.setAttribute("data-action", "click->bulk-options-advanced#selectAll")
    }
  }

  list() {
    if (this.hasListTarget) {
      return this.listTarget
    } else {
      return document
    }
  }

  // pobranie listy id obecnie zaznaczonych elementów (w formacie "1,2,3,4")
  getSelectedIds() {
    const list = this.list().querySelectorAll("input[name=\"ids[]\"]:checked")

    let ids = ""

    list.forEach(element => {
      ids += `${element.value},`
    })

    // usuwamy zbędny przecinek z końca parametrów
    if (ids.charAt(ids.length - 1) === ",") {
      ids = ids.slice(0, -1)
    }

    return ids
  }

  // aktualizacja licznika zaznaczonych elementów na stronie
  updateCounter() {
    if (!this.hasCounterTarget) { return true }

    const currentValue = this.list().querySelectorAll("input[name=\"ids[]\"]:checked").length

    this.counterTarget.children[0].innerHTML = currentValue

    if (currentValue > 0) {
      this.counterTarget.classList.remove("invisible")
      this.optionsDivTarget.classList.remove("hidden")
      if (this.hasTheadTarget) { this.theadTarget.classList.add("top-12") }
      if (this.hasBreadcrumbsAreaTarget) {
        // Jeśli target występuje wielokrotnie, ukrywamy wszystkie wystąpienia
        if (this.breadcrumbsAreaTargets && this.breadcrumbsAreaTargets.length) {
          this.breadcrumbsAreaTargets.forEach(el => el.classList.add("hidden"))
        } else if (this.breadcrumbsAreaTarget) {
          this.breadcrumbsAreaTarget.classList.add("hidden")
        }
      }
    } else {
      this.counterTarget.classList.add("invisible")
      this.optionsDivTarget.classList.add("hidden")
      if (this.hasTheadTarget) { this.theadTarget.classList.remove("top-12") }
      if (this.hasBreadcrumbsAreaTarget) {
        if (this.breadcrumbsAreaTargets && this.breadcrumbsAreaTargets.length) {
          this.breadcrumbsAreaTargets.forEach(el => el.classList.remove("hidden"))
        } else if (this.breadcrumbsAreaTarget) {
          this.breadcrumbsAreaTarget.classList.remove("hidden")
        }
      }
    }
  }

  // zaznaczenie checkboxa
  checkOption(event) {
    const input = event.target
    let newValue = input.checked
    let indexes = [-1, -1]
    const inputIndex = Array.prototype.indexOf.call(this.inputs, input)

    if (event.shiftKey && this.lastElement) {
      // jeśli kliknęliśmy z shiftem i nie był to pierwszy zaznaczony element to zaznaczamy zakres
      indexes[0] = Array.prototype.indexOf.call(this.inputs, document.querySelector(`input[value="${this.lastElement.value}"]`))
      indexes[1] = inputIndex

      indexes = indexes.sort((a, b) => { return a - b })
      newValue = this.lastElement.checked
    } else {
      // wpp zakresem jest pojedynczy checkbox
      indexes = [inputIndex, inputIndex]
    }

    Array.prototype.slice.call(this.inputs).slice(indexes[0], indexes[1] + 1).forEach(element => {
      element.checked = newValue
    })

    this.lastElement = { value: input.value, checked: input.checked }

    if (this.hasSelectTarget && !newValue) {
      this.selectTarget.checked = false
      document.getElementById("bulk-advanced-unchecked-all")?.classList?.add("hidden")
      document.getElementById("bulk-advanced-checked-all")?.classList?.add("hidden")
    }

    this.updateCounter()
  }

  // zaznaczenie/odznaczenie wszystkich checkboxów
  selectAll() {
    this.inputs = this.list().querySelectorAll("input[name=\"ids[]\"]")
    const checkBox = document.getElementById("bulk-advanced-bulk-all")
    const uncheckedText = document.getElementById("bulk-advanced-unchecked-all")
    const checkedText = document.getElementById("bulk-advanced-checked-all")

    if (this.selectTarget.checked) {
      this.inputs.forEach(element => {
        element.checked = true
      })
      uncheckedText?.classList?.remove("hidden")
      checkedText?.classList?.add("hidden")
    } else {
      this.inputs.forEach(element => {
        element.checked = false
      })
      uncheckedText?.classList?.add("hidden")
      checkedText?.classList?.add("hidden")
    }

    if (checkBox) { checkBox.checked = false }

    this.lastElement = null
    this.updateCounter()
  }

  submitForm(event) {
    const checkBox = document.getElementById("bulk-advanced-bulk-all")

    if (checkBox) {
      if (checkBox.checked && !confirm(checkBox.dataset.confirm)) {
        event.preventDefault()
      } else {
        event.target.addEventListener("turbo:submit-end", () => {
          const checkBox = document.getElementById("bulk-advanced-bulk-all")
          const uncheckedText = document.getElementById("bulk-advanced-unchecked-all")
          const checkedText = document.getElementById("bulk-advanced-checked-all")

          checkBox.checked = false
          if (this.selectTarget.checked) { uncheckedText?.classList?.remove("hidden") }
          checkedText?.classList?.add("hidden")
        })
      }
    }
  }

  checkAllList() {
    const checkBox = document.getElementById("bulk-advanced-bulk-all")
    const uncheckedText = document.getElementById("bulk-advanced-unchecked-all")
    const checkedText = document.getElementById("bulk-advanced-checked-all")

    checkBox.checked = !checkBox.checked
    if (!checkBox.checked) {
      this.selectTarget.click()
    } else {
      uncheckedText?.classList?.add("hidden")
      checkedText?.classList?.remove("hidden")
    }
  }
}
